export default __webpack_public_path__ + "db40c26c6b51ec0165d6bc0db77f03c3.png";